import React from 'react';
import { BookOpen, Info, Sparkles } from 'lucide-react';

const Footer = ({ onShowHelp }) => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="relative overflow-hidden mt-auto" style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    }}>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-white rounded-full blur-3xl"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-3 mb-4 md:mb-0">
            <div className="flex items-center gap-2 px-4 py-2 rounded-lg" style={{
              background: 'rgba(255, 255, 255, 0.15)',
              backdropFilter: 'blur(10px)',
            }}>
              <BookOpen className="h-5 w-5 text-white" />
              <span className="text-base font-bold text-white">ConfiData Pro</span>
            </div>
            <span className="text-sm text-white/80">© {currentYear}</span>
          </div>
          
          <div className="flex items-center space-x-4">
            <button
              onClick={onShowHelp}
              className="flex items-center gap-2 px-4 py-2 rounded-lg hover:scale-105 transition-transform"
              style={{
                background: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(10px)',
              }}
              title="Relancer le tutoriel d'introduction"
            >
              <Info className="h-4 w-4 text-white" />
              <span className="text-sm text-white font-medium">Aide</span>
            </button>
            
            <div className="flex items-center gap-2 px-3 py-1 rounded-full" style={{
              background: 'rgba(255, 255, 255, 0.1)',
            }}>
              <Sparkles className="h-4 w-4 text-yellow-300" />
              <span className="text-xs text-white font-medium">
                Gestion professionnelle sécurisée
              </span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1 rounded-full" style={{
              background: 'rgba(255, 255, 255, 0.1)',
            }}>
              <span className="text-xs text-white/90 font-medium">
                Version 2.2
              </span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1 rounded-full" style={{
              background: 'rgba(255, 255, 255, 0.1)',
            }}>
              <span className="text-xs text-white/90 font-medium">
                Développé par <span className="font-bold">youdemus</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
